import instance from '../../../api/axios'

export const loadFiles = async (folderId?: string): Promise<any> => {
  const response = await instance.get('/files', {
    params: folderId ? { folderId } : undefined,
  })

  return response.data
}

export default loadFiles
